import {Component, OnInit, ViewChild} from '@angular/core';
import { GlobalStateService } from './services/global-state.service';
import { LightboxComponent } from './photo-swipe/lightbox/lightbox.component';
import { LogRocketService } from './services/logrocket-service/logrocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild(LightboxComponent) photoSwipe: LightboxComponent;
  constructor(private globalStateService: GlobalStateService, private logRocketService: LogRocketService){

  }
  async ngOnInit() {
    this.logRocketService.initializeLogRocket();
    
    this.globalStateService.getOpenLightboxObservable.subscribe((res: any) => {
      this.openImage(res)
    })

    console.log('user platform:', this.getUserPlatform())
  }

  

  openImage(res:any){
    this.photoSwipe.openImage(res.Index ?? 0,res.Image,res.isGallery,res.isNoteList)
  }

   getUserPlatform() {
    var userAgent = navigator.userAgent;
    const platform = navigator.platform;
      // Windows Phone must come first because its UA also contains "Android"
      if (navigator.userAgent.includes("NokiaBrowser")) {

      return "WINDOWS_PHONE";//"WINDOWS-PHONE";
    }

    if (/android/i.test(userAgent)) {
      return "ANDROID";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    ) {///iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && !/Mac/.test(platform)) {
      return "IOS";
    }

    return this.getBrowserName(userAgent);
  }

  getBrowserName(userAgent:string): string {
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg') && !userAgent.includes('OPR')) {
      return 'Chrome';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return 'Safari';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('Edg')) {
      return 'Edge';
    } else if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
      return 'Opera';
    } else {
      return 'Unknown';
    }
  }

}
